import * as core from '../../../../../../../core'

import { query } from './stakeholder-log.query'

export const RESOURCE = {
  payload: {
    alias: 'stakeholder.log',
    description: 'Table view of the stakeholder log',
    name: 'Stakeholder Log',
    query,
    variables: [
      {
        id: 'departmentAndSubdepartment',
        name: 'Department & Subdepartment',
        type: {
          dimensionId: 'dim::!org',
          isMultiselect: false,
        },
      },
      {
        id: 'degreeOfImpact',
        name: 'Degree of Impact',
        type: {
          enumId: 'enum::!change_impact_rank',
          isMultiselect: false,
        },
      },
      {
        id: 'projectRole',
        name: 'Project Role',
        type: {
          enumId: 'enum::!stakeholder_project_role',
          isMultiselect: false,
        },
      },
      {
        id: 'influenceDecisionRole',
        name: 'Influence / Decision Role',
        type: {
          enumId: 'enum::!change_impact_rank',
          isMultiselect: false,
        },
      },
      {
        id: 'changeChampion',
        name: 'Change Champion',
        type: {
          enumId: 'enum::!stakeholder_change_champion',
          isMultiselect: false,
        },
      },
      {
        id: 'engagementNeeded',
        name: 'Engagement Needed',
        type: {
          enumId: 'enum::!stakeholder_engagement_needed',
          isMultiselect: false,
        },
      },
      {
        id: 'trainingAudienceNeed',
        name: 'Training Audience / Need',
        type: {
          enumId: 'enum::!stakeholder_training_audience',
          isMultiselect: false,
        },
      },
      {
        defaultValue: false,
        id: 'isProjectTeamMember',
        name: 'Project Team',
        type: core.common.value.types.Intrinsic.Boolean,
      },
    ],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
